module.exports = __webpack_public_path__ + "static/media/close.f808516d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/close.svg
// module id = 475
// module chunks = 0